/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-popover-background-color: Specifies the component's background color.
* @prop --calcite-popover-border-color: Specifies the component's border color.
* @prop --calcite-popover-corner-radius: Specifies the component's corner radius.
* @prop --calcite-popover-text-color: Specifies the component's text color.
* @prop --calcite-popover-z-index: Specifies the component's z-index value.
*/
:host {
  --calcite-floating-ui-z-index: var(--calcite-popover-z-index, var(--calcite-z-index-popup));
  display: block;
  position: absolute;
  z-index: var(--calcite-floating-ui-z-index);
}

.calcite-floating-ui-anim {
  position: relative;
  transition: var(--calcite-floating-ui-transition);
  transition-property: inset, left, opacity;
  opacity: 0;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.16);
  z-index: var(--calcite-z-index);
  border-radius: 0.25rem;
}

:host([data-placement^=bottom]) .calcite-floating-ui-anim {
  inset-block-start: -5px;
}

:host([data-placement^=top]) .calcite-floating-ui-anim {
  inset-block-start: 5px;
}

:host([data-placement^=left]) .calcite-floating-ui-anim {
  left: 5px;
}

:host([data-placement^=right]) .calcite-floating-ui-anim {
  left: -5px;
}

:host([data-placement]) .calcite-floating-ui-anim--active {
  opacity: 1;
  inset-block: 0;
  left: 0;
}

:host([calcite-hydrated-hidden]) {
  visibility: hidden !important;
  pointer-events: none;
}

.calcite-floating-ui-arrow {
  pointer-events: none;
  position: absolute;
  z-index: calc(var(--calcite-z-index) * -1);
  fill: var(--calcite-color-foreground-1);
}

.calcite-floating-ui-arrow__stroke {
  stroke: var(--calcite-color-border-3);
}

:host([scale=s]) .heading {
  padding-inline: 0.75rem;
  padding-block: 0.5rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}

:host([scale=m]) .heading {
  padding-inline: 1rem;
  padding-block: 0.75rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}

:host([scale=l]) .heading {
  padding-inline: 1.25rem;
  padding-block: 1rem;
  font-size: var(--calcite-font-size-1);
  line-height: 1.375;
}

:host {
  pointer-events: none;
}

:host([open]) {
  pointer-events: initial;
}

.calcite-floating-ui-anim {
  border-width: 1px;
  border-style: solid;
  background-color: var(--calcite-popover-background-color, var(--calcite-color-foreground-1));
  border-color: var(--calcite-popover-border-color, var(--calcite-color-border-3));
  border-radius: var(--calcite-popover-corner-radius, var(--calcite-corner-radius-round));
}

.calcite-floating-ui-arrow {
  fill: var(--calcite-popover-background-color, var(--calcite-color-foreground-1));
}

.calcite-floating-ui-arrow__stroke {
  stroke: var(--calcite-popover-border-color, var(--calcite-color-border-3));
}

.header {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  justify-content: flex-start;
  border-width: 0px;
  border-block-end-width: 1px;
  border-style: solid;
  border-block-end-color: var(--calcite-popover-border-color, var(--calcite-color-border-3));
}

.heading {
  margin: 0px;
  display: block;
  flex: 1 1 auto;
  align-self: center;
  white-space: normal;
  font-weight: var(--calcite-font-weight-medium);
  word-wrap: break-word;
  word-break: break-word;
  color: var(--calcite-popover-text-color, var(--calcite-color-text-1));
}

.headerContainer {
  position: relative;
  display: flex;
  block-size: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  border-radius: 0.25rem;
  color: var(--calcite-popover-text-color, var(--calcite-color-text-1));
}
.headerContainer.has-header {
  flex-direction: column;
}

.content {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  align-self: center;
  word-wrap: break-word;
  word-break: break-word;
}

.close-button-container {
  display: flex;
  overflow: hidden;
  flex: 0 0 auto;
  border-start-end-radius: var(--calcite-popover-corner-radius, var(--calcite-corner-radius-round));
  border-end-end-radius: var(--calcite-popover-corner-radius, var(--calcite-corner-radius-round));
  --calcite-action-corner-radius-start-end: var(--calcite-popover-corner-radius, var(--calcite-corner-radius-sharp));
  --calcite-action-corner-radius-end-end: var(--calcite-popover-corner-radius, var(--calcite-corner-radius-sharp));
}

::slotted(calcite-panel),
::slotted(calcite-flow) {
  block-size: 100%;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}